import React from "react"
import {useTranslation} from "react-i18next"
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core"

// Styles
import useStyles from "./styles"

type InactivityWarningDialogProps = {
    onClose(): void
    onTimeElapsed(): void
}

const LAST_SECONDS = 60;

/**
 * @param props
 */
export default function InactivityWarningDialog(props: InactivityWarningDialogProps) {
    const styles = useStyles();
    const [t] = useTranslation("common");
    const {onTimeElapsed, onClose} = props;
    const [seconds, setSeconds] = React.useState(LAST_SECONDS);

    React.useEffect(() => {
        const timeoutId = window.setTimeout(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            } else {
                window.clearTimeout(timeoutId);
                onTimeElapsed();
            }
        }, 1000);

        return () => {
            window.clearTimeout(timeoutId)
        }
    }, [seconds, onTimeElapsed]);

    return (
        <Dialog open={true} onClose={onClose} PaperProps={{className: styles.dialog}}>
            <DialogTitle>{t("records.are_you_still_here")}</DialogTitle>
            <DialogContent>
                <span className={styles.warning_text}>
                    {t("records.re_assign_warning_text")}:
                    &nbsp;
                </span>
                <span className={styles.seconds}>{seconds}s</span>
            </DialogContent>
            <DialogActions className={styles.actions}>
                <Button color="primary"
                        onClick={onClose}
                        variant="contained">{t("records.i_am_here")}</Button>
            </DialogActions>
        </Dialog>
    )
}
